import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock, Facebook, Instagram, Star, ExternalLink } from "lucide-react";

export const Footer = () => {
  return (
    <footer className="bg-slate-900 text-white">
      {/* Main Footer */}
      <div className="container-custom py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {/* Company Info */}
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_repair-mediastore/artifacts/iux4q1ae_679b64502f0000bac0f5978e.webp" 
                alt="Mediastore" 
                className="h-10 w-auto rounded-xl logo-shine"
              />
            </Link>
            <p className="text-slate-400 text-sm mb-4">
              Votre expert en réparation de téléphones et ordinateurs à Niort depuis plus de 10 ans.
            </p>
            
            {/* Google Rating */}
            <div className="flex items-center gap-2 bg-slate-800 rounded-lg px-4 py-3 mb-4">
              <div className="flex items-center">
                <Star className="h-4 w-4 text-yellow-400 fill-yellow-400" />
                <Star className="h-4 w-4 text-yellow-400 fill-yellow-400" />
                <Star className="h-4 w-4 text-yellow-400 fill-yellow-400" />
                <Star className="h-4 w-4 text-yellow-400 fill-yellow-400" />
                <Star className="h-4 w-4 text-slate-600" />
              </div>
              <span className="font-semibold">4,6/5</span>
              <span className="text-slate-400 text-sm">(212 avis)</span>
            </div>

            {/* Social Links */}
            <div className="flex items-center gap-3">
              <a 
                href="https://www.tiktok.com/@mediastore79" 
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-slate-800 hover:bg-black flex items-center justify-center transition-colors"
                aria-label="TikTok Mediastore Niort - @mediastore79"
                data-testid="footer-tiktok"
              >
                <svg className="h-5 w-5" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                  <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5.8 20.1a6.34 6.34 0 0 0 10.86-4.43V8.46a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1.84-.39Z"/>
                </svg>
              </a>
              <a 
                href="https://www.facebook.com/mediastore79"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-slate-800 hover:bg-blue-600 flex items-center justify-center transition-colors"
                aria-label="Facebook Mediastore Niort"
                data-testid="footer-facebook"
              >
                <Facebook className="h-5 w-5" />
              </a>
              <a 
                href="#" 
                className="w-10 h-10 rounded-full bg-slate-800 hover:bg-pink-600 flex items-center justify-center transition-colors"
                aria-label="Instagram"
                data-testid="footer-instagram"
              >
                <Instagram className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Services Links */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Nos Services</h3>
            <ul className="space-y-3">
              <li>
                <Link 
                  to="/reparation-telephone"
                  className="text-slate-400 hover:text-white transition-colors text-sm"
                  data-testid="footer-link-reparation-telephone"
                >
                  Réparation Téléphone & Tablette
                </Link>
              </li>
              <li>
                <Link 
                  to="/reparation-ordinateur"
                  className="text-slate-400 hover:text-white transition-colors text-sm"
                  data-testid="footer-link-reparation-ordinateur"
                >
                  Réparation Ordinateur
                </Link>
              </li>
              <li>
                <Link 
                  to="/services-professionnels"
                  className="text-slate-400 hover:text-white transition-colors text-sm"
                  data-testid="footer-link-services-professionnels"
                >
                  Services Professionnels
                </Link>
              </li>
              <li>
                <Link 
                  to="/urgence"
                  className="text-slate-400 hover:text-white transition-colors text-sm"
                  data-testid="footer-link-urgence"
                >
                  Réparation Urgente
                </Link>
              </li>
            </ul>

            {/* Sous-section Spécialités SEO Niort */}
            <h3 className="font-semibold text-base mt-8 mb-3">Spécialités Niort</h3>
            <ul className="space-y-2">
              <li><Link to="/reparation-iphone-niort" className="text-slate-400 hover:text-white transition-colors text-sm" data-testid="footer-link-iphone-niort">Réparation iPhone Niort</Link></li>
              <li><Link to="/reparation-mac-niort" className="text-slate-400 hover:text-white transition-colors text-sm" data-testid="footer-link-mac-niort">Réparation Mac Niort</Link></li>
              <li><Link to="/reparation-ipad-niort" className="text-slate-400 hover:text-white transition-colors text-sm" data-testid="footer-link-ipad-niort">Réparation iPad Niort</Link></li>
              <li><Link to="/reparation-multimarque-niort" className="text-slate-400 hover:text-white transition-colors text-sm" data-testid="footer-link-multimarque-niort">Samsung, Huawei, Xiaomi…</Link></li>
              <li><Link to="/iphone-reconditionne-niort" className="text-slate-400 hover:text-white transition-colors text-sm" data-testid="footer-link-reconditionne-niort">iPhone Reconditionné</Link></li>
              <li><Link to="/reprise-iphone-niort" className="text-slate-400 hover:text-white transition-colors text-sm" data-testid="footer-link-reprise-niort">Reprise & Dépôt-vente iPhone</Link></li>
              <li><Link to="/pannes-reparations" className="text-slate-400 hover:text-white transition-colors text-sm font-semibold" data-testid="footer-link-pannes">🔧 Toutes les pannes &amp; tarifs</Link></li>
              <li><Link to="/villes-desservies" className="text-slate-400 hover:text-white transition-colors text-sm" data-testid="footer-link-villes">📍 Villes desservies (80 km)</Link></li>
              <li><Link to="/reparations-locales" className="text-slate-400 hover:text-white transition-colors text-sm" data-testid="footer-link-locales">🗺️ Réparations locales (216 pages)</Link></li>
              <li><Link to="/ia-niort" className="text-slate-400 hover:text-white transition-colors text-sm font-semibold" data-testid="footer-link-ai-hub">🤖 Centre IA (69 Q/R)</Link></li>
              <li><Link to="/guides" className="text-slate-400 hover:text-white transition-colors text-sm font-semibold" data-testid="footer-link-guides">📚 Guides experts (30)</Link></li>
              <li><Link to="/etudes-de-cas" className="text-slate-400 hover:text-white transition-colors text-sm" data-testid="footer-link-cases">🎯 Études de cas (20)</Link></li>
              <li><Link to="/comparatifs" className="text-slate-400 hover:text-white transition-colors text-sm" data-testid="footer-link-comparisons">⚖️ Comparatifs (10)</Link></li>
              <li><Link to="/blog" className="text-slate-400 hover:text-white transition-colors text-sm font-semibold" data-testid="footer-link-blog">📰 Blog &amp; Conseils</Link></li>
            </ul>
          </div>

          {/* Information Links */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Informations</h3>
            <ul className="space-y-3">
              <li>
                <Link 
                  to="/avis-clients"
                  className="text-slate-400 hover:text-white transition-colors text-sm"
                >
                  Avis Clients
                </Link>
              </li>
              <li>
                <Link 
                  to="/contact"
                  className="text-slate-400 hover:text-white transition-colors text-sm"
                >
                  Contact
                </Link>
              </li>
              <li>
                <Link 
                  to="/garantie"
                  className="text-slate-400 hover:text-white transition-colors text-sm"
                >
                  Conditions de Garantie
                </Link>
              </li>
              <li>
                <Link 
                  to="/mentions-legales"
                  className="text-slate-400 hover:text-white transition-colors text-sm"
                  data-testid="footer-link-mentions-legales"
                >
                  Mentions Légales
                </Link>
              </li>
              <li>
                <Link 
                  to="/politique-de-confidentialite"
                  className="text-slate-400 hover:text-white transition-colors text-sm"
                  data-testid="footer-link-confidentialite"
                >
                  Politique de Confidentialité
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Contact</h3>
            <ul className="space-y-4">
              <li>
                <a 
                  href="tel:+33549057490"
                  className="flex items-start gap-3 text-slate-400 hover:text-white transition-colors group"
                  data-testid="footer-phone"
                >
                  <Phone className="h-5 w-5 mt-0.5 text-blue-500 group-hover:text-blue-400" />
                  <span className="text-sm font-medium">05 49 05 74 90</span>
                </a>
              </li>
              <li>
                <a 
                  href="mailto:imediastore79@gmail.com"
                  className="flex items-start gap-3 text-slate-400 hover:text-white transition-colors group"
                  data-testid="footer-email"
                >
                  <Mail className="h-5 w-5 mt-0.5 text-blue-500 group-hover:text-blue-400" />
                  <span className="text-sm">imediastore79@gmail.com</span>
                </a>
              </li>
              <li>
                <a 
                  href="https://www.google.com/maps/place/104+Rue+de+la+Gare,+79000+Niort,+France"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-start gap-3 text-slate-400 hover:text-white transition-colors group"
                  data-testid="footer-address"
                >
                  <MapPin className="h-5 w-5 mt-0.5 text-blue-500 group-hover:text-blue-400" />
                  <span className="text-sm">104 Rue de la Gare, 79000 Niort, France</span>
                </a>
              </li>
              <li>
                <div className="flex items-start gap-3 text-slate-400">
                  <Clock className="h-5 w-5 mt-0.5 text-green-500" />
                  <div className="text-sm">
                    <div className="flex justify-between gap-4">
                      <span>Lundi - Vendredi</span>
                      <span className="text-white">10h00 - 18h00</span>
                    </div>
                    <div className="flex justify-between gap-4">
                      <span>Samedi</span>
                      <span className="text-white">10h00 - 16h00</span>
                    </div>
                    <div className="flex justify-between gap-4">
                      <span>Dimanche</span>
                      <span className="text-white">Fermé</span>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-slate-800">
        <div className="container-custom py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-slate-400">
            <p>© 2026 Mediastore. Tous droits réservés.</p>
            <p className="flex items-center gap-1">
              Réparation téléphone et ordinateur à Niort
              <ExternalLink className="h-3 w-3" />
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};
